import { normalizeISODateString } from '../../EnergyLevelPage/components/suggested-actions/utils/dateUtils'

// Renders a date as "MMM d" (e.g. "Jun 2"), or "MMM d, yyyy" with { withYear }
// (e.g. the Team Energy "Updated" snapshot date). The date is built from the
// calendar components of the string rather than parsing it into an instant, so
// the stored calendar day is shown regardless of the viewer's timezone. Mirrors
// the timezone-safe handling on the Energy Level page suggestion cards.
export function formatShortDate(value: string, locale: string, options?: { withYear?: boolean }): string {
  const [year, month, day] = normalizeISODateString(value).split('-').map(Number)
  if (!year || !month || !day) {
    return value
  }
  return new Intl.DateTimeFormat(locale, {
    month: 'short',
    day: 'numeric',
    ...(options?.withYear ? { year: 'numeric' } : {}),
  }).format(new Date(year, month - 1, day))
}
